export const SEARCH_TYPES_WITH_FILTERS = ['arret', 'commentary', 'law'];
